import { BulkMessagesQueries } from '@frontend/api-messaging';
import { useAppScopeStore } from '@frontend/scope';
import { isBulkTextingSupportedInCountry } from './is-bulk-texting-supported-in-country';

export const useCheckTollFreePhoneNumber = () => {
  const { selectedLocationIds } = useAppScopeStore();
  const locationId = selectedLocationIds[0];

  const { data: tcrBrandData } = BulkMessagesQueries.useLocationTCRBrand(locationId);
  const isSupportedCountry = isBulkTextingSupportedInCountry(tcrBrandData?.country);

  const { data: tenDlcRegisteredData } = BulkMessagesQueries.useTenDLCLocationRegistrationStatus({
    locationId,
    enabled: isSupportedCountry && !!locationId,
  });

  const isTollFreePhoneNumber = checkIsTollFreePhoneNumber(tenDlcRegisteredData?.defaultSmsNumber);
  return isTollFreePhoneNumber;
};

const checkIsTollFreePhoneNumber = (phoneNumber?: string): boolean => {
  if (!phoneNumber) return false;
  const tollFreeNumberRegex = /^(?:1)?(?:800|888|877|866|855|844|833)[0-9]{7}$/;
  const parsedPhoneNumber = phoneNumber.replace(/[^\d.-]+/g, '');
  return tollFreeNumberRegex.test(parsedPhoneNumber);
};
